"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _legacyVideo = _interopRequireDefault(require("@entrylabs/legacy-video"));
var _clamp = _interopRequireDefault(require("lodash/clamp"));
var _GEHelper = require("../../graphicEngine/GEHelper");
Entry.VideoUtils = _legacyVideo["default"];
Entry.AI_UTILIZE_BLOCK.video = {
  name: 'video',
  imageName: 'video.svg',
  category: 'video',
  title: {
    ko: '비디오 감지',
    en: 'Video Detection',
    jp: 'ビデオ検出'
  },
  titleKey: 'template.video_title_text',
  description: Lang.Msgs.ai_utilize_video_description,
  descriptionKey: 'Msgs.ai_utilize_video_description',
  isInitialized: false,
  init: function init() {
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
          case 1:
            Entry.AI_UTILIZE_BLOCK.video.isInitialized = true;
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  destroy: function destroy() {
    _legacyVideo["default"].destroy();
    Entry.AI_UTILIZE_BLOCK.video.isInitialized = false;
  }
};
Entry.AI_UTILIZE_BLOCK.video.getBlocks = function () {
  var params = {
    getCommonIndicator: function getCommonIndicator() {
      return {
        type: 'Indicator',
        img: 'block_icon/ai_utilize_icon.svg',
        size: 11
      };
    },
    getCameraOrder: function getCameraOrder() {
      return {
        type: 'DropdownDynamic',
        menuName: 'connectedCameras',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getNumbers: function getNumbers() {
      return {
        type: 'Dropdown',
        options: [['1', 0], ['2', 1], ['3', 2], ['4', 3]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getOnOff: function getOnOff() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_show_video, 'on'], [Lang.Blocks.video_hide_video, 'off']],
        value: 'on',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getVideoFlipOptions: function getVideoFlipOptions() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_left_right, 'hflip'], [Lang.Blocks.video_top_bottom, 'vflip']],
        value: 'hflip',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getAiModelOptions: function getAiModelOptions() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_human, 'pose'], [Lang.Blocks.video_face, 'face'], [Lang.Blocks.video_object, 'object']],
        value: 'pose',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getSwitchOptions: function getSwitchOptions() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_start, 'on'], [Lang.Blocks.video_end, 'off']],
        value: 'on',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getFaceInfoOptions: function getFaceInfoOptions() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_gender, 'gender'], [Lang.Blocks.video_age, 'age'], [Lang.Blocks.video_emotion, 'emotion']],
        value: 'gender',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getFaceCoords: function getFaceCoords() {
      return {
        type: 'Dropdown',
        options: [[Lang.video_body_coord_params.left_eye, 45], [Lang.video_body_coord_params.right_eye, 36], [Lang.video_body_coord_params.nose, 30], [Lang.video_body_coord_params.left_mouth, 54], [Lang.video_body_coord_params.right_mouth, 48], [Lang.video_body_coord_params.upper_lip, 62], [Lang.video_body_coord_params.lower_lip, 66]],
        value: 45,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getBodyCoords: function getBodyCoords() {
      return {
        type: 'Dropdown',
        options: [[Lang.video_body_coord_params.face, 0], [Lang.video_body_coord_params.neck, 21], [Lang.video_body_coord_params.left_eye, 1], [Lang.video_body_coord_params.right_eye, 2], [Lang.video_body_coord_params.left_ear, 3], [Lang.video_body_coord_params.right_ear, 4], [Lang.video_body_coord_params.left_shoulder, 5], [Lang.video_body_coord_params.right_shoulder, 6], [Lang.video_body_coord_params.left_elbow, 7], [Lang.video_body_coord_params.right_elbow, 8], [Lang.video_body_coord_params.left_wrist, 9], [Lang.video_body_coord_params.right_wrist, 10], [Lang.video_body_coord_params.left_hip, 11], [Lang.video_body_coord_params.right_hip, 12], [Lang.video_body_coord_params.left_knee, 13], [Lang.video_body_coord_params.right_knee, 14], [Lang.video_body_coord_params.left_ankle, 15], [Lang.video_body_coord_params.right_ankle, 16]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getCoordXYOptions: function getCoordXYOptions() {
      return {
        type: 'Dropdown',
        options: [['x', 'x'], ['y', 'y']],
        value: 'x',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getObjectList: function getObjectList() {
      return {
        type: 'DropdownExtra',
        options: [[Lang.video_object_params.person, 'person'], [Lang.video_object_params.bicycle, 'bicycle'], [Lang.video_object_params.car, 'car'], [Lang.video_object_params.motorcycle, 'motorcycle'], [Lang.video_object_params.airplane, 'airplane'], [Lang.video_object_params.bus, 'bus'], [Lang.video_object_params.train, 'train'], [Lang.video_object_params.truck, 'truck'], [Lang.video_object_params.boat, 'boat'], [Lang.video_object_params['traffic light'], 'traffic light'], [Lang.video_object_params['fire hydrant'], 'fire hydrant'], [Lang.video_object_params['stop sign'], 'stop sign'], [Lang.video_object_params['parking meter'], 'parking meter'], [Lang.video_object_params.bench, 'bench'], [Lang.video_object_params.bird, 'bird'], [Lang.video_object_params.cat, 'cat'], [Lang.video_object_params.dog, 'dog'], [Lang.video_object_params.horse, 'horse'], [Lang.video_object_params.sheep, 'sheep'], [Lang.video_object_params.cow, 'cow'], [Lang.video_object_params.elephant, 'elephant'], [Lang.video_object_params.bear, 'bear'], [Lang.video_object_params.zebra, 'zebra'], [Lang.video_object_params.giraffe, 'giraffe'], [Lang.video_object_params.backpack, 'backpack'], [Lang.video_object_params.umbrella, 'umbrella'], [Lang.video_object_params.handbag, 'handbag'], [Lang.video_object_params.tie, 'tie'], [Lang.video_object_params.suitcase, 'suitcase'], [Lang.video_object_params.frisbee, 'frisbee'], [Lang.video_object_params.skis, 'skis'], [Lang.video_object_params.snowboard, 'snowboard'], [Lang.video_object_params['sports ball'], 'sports ball'], [Lang.video_object_params.kite, 'kite'], [Lang.video_object_params['baseball bat'], 'baseball bat'], [Lang.video_object_params['baseball glove'], 'baseball glove'], [Lang.video_object_params.skateboard, 'skateboard'], [Lang.video_object_params.surfboard, 'surfboard'], [Lang.video_object_params['tennis racket'], 'tennis racket'], [Lang.video_object_params.bottle, 'bottle'], [Lang.video_object_params['wine glass'], 'wine glass'], [Lang.video_object_params.cup, 'cup'], [Lang.video_object_params.fork, 'fork'], [Lang.video_object_params.knife, 'knife'], [Lang.video_object_params.spoon, 'spoon'], [Lang.video_object_params.bowl, 'bowl'], [Lang.video_object_params.banana, 'banana'], [Lang.video_object_params.apple, 'apple'], [Lang.video_object_params.sandwich, 'sandwich'], [Lang.video_object_params.orange, 'orange'], [Lang.video_object_params.broccoli, 'broccoli'], [Lang.video_object_params.carrot, 'carrot'], [Lang.video_object_params['hot dog'], 'hot dog'], [Lang.video_object_params.pizza, 'pizza'], [Lang.video_object_params.donut, 'donut'], [Lang.video_object_params.cake, 'cake'], [Lang.video_object_params.chair, 'chair'], [Lang.video_object_params.couch, 'couch'], [Lang.video_object_params['potted plant'], 'potted plant'], [Lang.video_object_params.bed, 'bed'], [Lang.video_object_params['dining table'], 'dining table'], [Lang.video_object_params.toilet, 'toilet'], [Lang.video_object_params.tv, 'tv'], [Lang.video_object_params.laptop, 'laptop'], [Lang.video_object_params.mouse, 'mouse'], [Lang.video_object_params.remote, 'remote'], [Lang.video_object_params.keyboard, 'keyboard'], [Lang.video_object_params['cell phone'], 'cell phone'], [Lang.video_object_params.microwave, 'microwave'], [Lang.video_object_params.oven, 'oven'], [Lang.video_object_params.toaster, 'toaster'], [Lang.video_object_params.sink, 'sink'], [Lang.video_object_params.refrigerator, 'refrigerator'], [Lang.video_object_params.book, 'book'], [Lang.video_object_params.clock, 'clock'], [Lang.video_object_params.vase, 'vase'], [Lang.video_object_params.scissors, 'scissors'], [Lang.video_object_params['teddy bear'], 'teddy bear'], [Lang.video_object_params['hair drier'], 'hair drier'], [Lang.video_object_params.toothbrush, 'toothbrush']],
        value: 'bicycle',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    }
  };
  return {
    video_title: {
      skeleton: 'basic_text',
      color: EntryStatic.colorSet.common.TRANSPARENT,
      params: [{
        type: 'Text',
        text: Lang.template.video_title_text,
        color: EntryStatic.colorSet.common.TEXT,
        align: 'center'
      }],
      def: {
        type: 'video_title'
      },
      "class": 'video',
      isNotFor: ['video'],
      events: {}
    },
    video_change_cam: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getCameraOrder(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'video_change_cam'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var VALUE;
          return _regenerator["default"].wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                VALUE = script.getField('VALUE');
                _context2.next = 1;
                return _legacyVideo["default"].changeSource(VALUE);
              case 1:
                return _context2.abrupt("return", _context2.sent);
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_check_webcam: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [],
      events: {},
      def: {
        type: 'video_check_webcam'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return _legacyVideo["default"].videoInputList.length > 0;
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_draw_webcam: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getOnOff(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'video_draw_webcam'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          var value;
          return _regenerator["default"].wrap(function (_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                value = script.getField('VALUE');
                if (_legacyVideo["default"].isInitialized) {
                  _context3.next = 1;
                  break;
                }
                _context3.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                _legacyVideo["default"].cameraSwitch(value);
                return _context3.abrupt("return", script.callReturn());
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_set_camera_opacity_option: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [{
        type: 'Block',
        accept: 'string',
        defaultType: 'number',
        value: '0'
      }, params.getCommonIndicator()],
      events: {},
      def: {
        type: 'video_set_camera_opacity_option'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
          var value, _t;
          return _regenerator["default"].wrap(function (_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                value = (0, _clamp["default"])(script.getNumberValue('VALUE'), 0, 100);
                _context4.prev = 1;
                if (_legacyVideo["default"].isInitialized) {
                  _context4.next = 2;
                  break;
                }
                _context4.next = 2;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 2:
                _legacyVideo["default"].setOptions('transparency', value);
                return _context4.abrupt("return", script.callReturn());
              case 3:
                _context4.prev = 3;
                _t = _context4["catch"](1);
                console.log(_t);
                throw _t;
              case 4:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[1, 3]]);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_flip_camera: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getVideoFlipOptions(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'video_flip_camera'
      },
      paramsKeyMap: {
        TARGET: 0
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
          var target;
          return _regenerator["default"].wrap(function (_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                target = script.getField('TARGET');
                if (_legacyVideo["default"].isInitialized) {
                  _context5.next = 1;
                  break;
                }
                _context5.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                _legacyVideo["default"].setOptions(target);
                return _context5.abrupt("return", script.callReturn());
              case 2:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_toggle_model: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getAiModelOptions(), params.getSwitchOptions(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'video_toggle_model'
      },
      paramsKeyMap: {
        TARGET: 0,
        MODE: 1
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
          var target, mode;
          return _regenerator["default"].wrap(function (_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                target = script.getField('TARGET');
                mode = script.getField('MODE');
                if (_legacyVideo["default"].isInitialized) {
                  _context6.next = 1;
                  break;
                }
                _context6.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                _legacyVideo["default"].manageModel(target, mode);
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_toggle_ind: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getAiModelOptions(), params.getOnOff(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'video_toggle_ind'
      },
      paramsKeyMap: {
        CRITERIA: 0,
        OPTION: 1
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
          var criteria, option;
          return _regenerator["default"].wrap(function (_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                criteria = script.getField('CRITERIA');
                option = script.getField('OPTION');
                if (_legacyVideo["default"].isInitialized) {
                  _context7.next = 1;
                  break;
                }
                _context7.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                if (option === 'on') {
                  _legacyVideo["default"].showIndicator(criteria);
                } else {
                  _legacyVideo["default"].removeIndicator(criteria);
                }
              case 2:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_number_detect: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [params.getAiModelOptions()],
      events: {},
      def: {
        type: 'video_number_detect'
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8() {
          var target, _t2;
          return _regenerator["default"].wrap(function (_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                target = script.getField('TARGET');
                if (_legacyVideo["default"].isInitialized) {
                  _context8.next = 1;
                  break;
                }
                _context8.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                _t2 = target;
                _context8.next = _t2 === 'face' ? 2 : _t2 === 'pose' ? 3 : _t2 === 'object' ? 4 : 5;
                break;
              case 2:
                return _context8.abrupt("return", _legacyVideo["default"].faces.length || 0);
              case 3:
                return _context8.abrupt("return", _legacyVideo["default"].poses && _legacyVideo["default"].poses.predictions.length || 0);
              case 4:
                return _context8.abrupt("return", _legacyVideo["default"].objects.length || 0);
              case 5:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }))();
      },
      paramsKeyMap: {
        TARGET: 0
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_object_detected: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [params.getObjectList()],
      events: {},
      def: {
        type: 'video_object_detected'
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9() {
          var target, result;
          return _regenerator["default"].wrap(function (_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                target = script.getField('TARGET');
                if (_legacyVideo["default"].isInitialized) {
                  _context9.next = 1;
                  break;
                }
                _context9.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                result = false;
                _legacyVideo["default"].objects.forEach(function (detected) {
                  if (detected["class"] === target) {
                    result = true;
                  }
                });
                return _context9.abrupt("return", result);
              case 2:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }))();
      },
      paramsKeyMap: {
        TARGET: 0
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    // 원래는 video_is_model_detected 로 나가야 하나, 해당 부분에 있어서 기존 하위 호환성때문에... 이름을 못바꿈...
    video_is_model_loaded: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [params.getAiModelOptions()],
      events: {},
      def: {
        type: 'video_is_model_loaded'
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0() {
          var target, _t3;
          return _regenerator["default"].wrap(function (_context0) {
            while (1) switch (_context0.prev = _context0.next) {
              case 0:
                target = script.getField('TARGET');
                if (_legacyVideo["default"].isInitialized) {
                  _context0.next = 2;
                  break;
                }
                _context0.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                return _context0.abrupt("return", false);
              case 2:
                _t3 = target;
                _context0.next = _t3 === 'face' ? 3 : _t3 === 'pose' ? 4 : _t3 === 'object' ? 5 : 6;
                break;
              case 3:
                return _context0.abrupt("return", _legacyVideo["default"].faces.length > 0);
              case 4:
                return _context0.abrupt("return", _legacyVideo["default"].poses && _legacyVideo["default"].poses.predictions.length > 0);
              case 5:
                return _context0.abrupt("return", _legacyVideo["default"].objects.length > 0);
              case 6:
              case "end":
                return _context0.stop();
            }
          }, _callee0);
        }))();
      },
      paramsKeyMap: {
        TARGET: 0
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_detected_face_info: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [params.getNumbers(), params.getFaceInfoOptions()],
      events: {},
      def: {
        type: 'video_detected_face_info'
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1() {
          var index, info, faces, target, emotion, maxVal, status, emotionVal, _t4;
          return _regenerator["default"].wrap(function (_context1) {
            while (1) switch (_context1.prev = _context1.next) {
              case 0:
                index = script.getField('INDEX');
                info = script.getField('INFO');
                faces = _legacyVideo["default"].faces;
                if (_legacyVideo["default"].isInitialized) {
                  _context1.next = 1;
                  break;
                }
                _context1.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                if (!(faces.length <= index)) {
                  _context1.next = 2;
                  break;
                }
                return _context1.abrupt("return", 0);
              case 2:
                target = _legacyVideo["default"].faces[index];
                if (target) {
                  _context1.next = 3;
                  break;
                }
                return _context1.abrupt("return", 0);
              case 3:
                _t4 = info;
                _context1.next = _t4 === 'gender' ? 4 : _t4 === 'age' ? 5 : _t4 === 'emotion' ? 6 : 7;
                break;
              case 4:
                return _context1.abrupt("return", Lang.video_gender[target.gender]);
              case 5:
                return _context1.abrupt("return", target.age.toFixed(0).toString());
              case 6:
                emotion = '';
                maxVal = 0;
                for (status in target.expressions) {
                  emotionVal = target.expressions[status];
                  if (emotionVal > maxVal) {
                    maxVal = emotionVal;
                    emotion = status;
                  }
                }
                return _context1.abrupt("return", Lang.video_emotion_params[emotion]);
              case 7:
              case "end":
                return _context1.stop();
            }
          }, _callee1);
        }))();
      },
      paramsKeyMap: {
        INDEX: 0,
        INFO: 1
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_motion_value: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [{
        type: 'Dropdown',
        options: [[Lang.Blocks.video_motion_onself, 'self'], [Lang.Blocks.video_motion_onscreen, 'screen']],
        value: 'self',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      }, {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_motion_scale, 'total'], [Lang.Blocks.video_motion_direction_horizontal, 'x'], [Lang.Blocks.video_motion_direction_vertical, 'y']],
        value: 'total',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      }],
      events: {},
      def: {
        type: 'video_motion_value'
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10() {
          var target, type, detected, rawX, rawY, absX, absY, _t5;
          return _regenerator["default"].wrap(function (_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                target = script.getField('TARGET');
                type = script.getField('TYPE');
                detected = _legacyVideo["default"].totalMotions;
                if (_legacyVideo["default"].isInitialized) {
                  _context10.next = 1;
                  break;
                }
                _context10.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                if (target === 'self') {
                  detected = _legacyVideo["default"].motionDetect(sprite);
                }
                if (!(type === 'total')) {
                  _context10.next = 2;
                  break;
                }
                return _context10.abrupt("return", (0, _clamp["default"])(detected.total / 10, 0, 100000).toString());
              case 2:
                _context10.prev = 2;
                rawX = detected.direction.x;
                if (!_legacyVideo["default"].flipStatus.horizontal) {
                  rawX *= -1;
                }
                rawY = detected.direction.y;
                if (_legacyVideo["default"].flipStatus.vertical) {
                  rawY *= -1;
                }
                absX = Math.abs(rawX);
                absY = Math.abs(rawY);
                if (!(absX < 20 && absY < 20)) {
                  _context10.next = 3;
                  break;
                }
                return _context10.abrupt("return", 0);
              case 3:
                if (!(type === 'x')) {
                  _context10.next = 4;
                  break;
                }
                return _context10.abrupt("return", rawX.toFixed(1).toString());
              case 4:
                if (!(type === 'y')) {
                  _context10.next = 5;
                  break;
                }
                return _context10.abrupt("return", rawY.toFixed(1).toString());
              case 5:
                return _context10.abrupt("return", 0);
              case 6:
                _context10.prev = 6;
                _t5 = _context10["catch"](2);
                console.log(detected);
              case 7:
              case "end":
                return _context10.stop();
            }
          }, _callee10, null, [[2, 6]]);
        }))();
      },
      paramsKeyMap: {
        TARGET: 0,
        TYPE: 1
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_face_part_coord: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [params.getNumbers(), params.getFaceCoords(), params.getCoordXYOptions()],
      events: {},
      def: {
        type: 'video_face_part_coord'
      },
      paramsKeyMap: {
        INDEX: 0,
        PART: 1,
        COORD: 2
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11() {
          var index, part, coord, faces, rawValue, returningValue, _t6;
          return _regenerator["default"].wrap(function (_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                index = script.getField('INDEX');
                part = script.getField('PART');
                coord = script.getField('COORD');
                if (_legacyVideo["default"].isInitialized) {
                  _context11.next = 1;
                  break;
                }
                _context11.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                if (_legacyVideo["default"].faces) {
                  _context11.next = 2;
                  break;
                }
                return _context11.abrupt("return", 0);
              case 2:
                _context11.prev = 2;
                faces = _legacyVideo["default"].faces;
                if (!(faces.length <= index)) {
                  _context11.next = 3;
                  break;
                }
                return _context11.abrupt("return", 0);
              case 3:
                // offset since value shown starts from 1;
                rawValue = faces[index].landmarks._positions[part]["_".concat(coord)];
                if (rawValue) {
                  _context11.next = 4;
                  break;
                }
                return _context11.abrupt("return", 0);
              case 4:
                returningValue = 0;
                if (coord === 'x') {
                  returningValue = rawValue - _legacyVideo["default"].CANVAS_WIDTH / 2;
                  if (_legacyVideo["default"].flipStatus.horizontal) {
                    returningValue *= -1;
                  }
                } else {
                  returningValue = _legacyVideo["default"].CANVAS_HEIGHT / 2 - rawValue;
                  if (_legacyVideo["default"].flipStatus.vertical) {
                    returningValue *= -1;
                  }
                }
                return _context11.abrupt("return", returningValue.toFixed(1));
              case 5:
                _context11.prev = 5;
                _t6 = _context11["catch"](2);
                return _context11.abrupt("return", 0);
              case 6:
              case "end":
                return _context11.stop();
            }
          }, _callee11, null, [[2, 5]]);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    },
    video_body_part_coord: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [params.getNumbers(), params.getBodyCoords(), params.getCoordXYOptions()],
      events: {},
      def: {
        type: 'video_body_part_coord'
      },
      paramsKeyMap: {
        INDEX: 0,
        PART: 1,
        COORD: 2
      },
      "class": 'video',
      isNotFor: ['video'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12() {
          var index, part, coord, poses, rawValue, returningValue, _t7;
          return _regenerator["default"].wrap(function (_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                index = script.getField('INDEX');
                part = script.getField('PART');
                coord = script.getField('COORD');
                if (_legacyVideo["default"].isInitialized) {
                  _context12.next = 1;
                  break;
                }
                _context12.next = 1;
                return _legacyVideo["default"].initialize(_GEHelper.GEHelper);
              case 1:
                if (!(!_legacyVideo["default"].poses || !_legacyVideo["default"].poses.predictions)) {
                  _context12.next = 2;
                  break;
                }
                return _context12.abrupt("return", 0);
              case 2:
                _context12.prev = 2;
                poses = _legacyVideo["default"].poses.predictions;
                if (!(poses.length < index)) {
                  _context12.next = 3;
                  break;
                }
                return _context12.abrupt("return", 0);
              case 3:
                // offset since value shown starts from 1;
                rawValue = poses[index].keypoints[part].position[coord];
                if (rawValue) {
                  _context12.next = 4;
                  break;
                }
                return _context12.abrupt("return", 0);
              case 4:
                returningValue = 0;
                if (coord === 'x') {
                  returningValue = rawValue - _legacyVideo["default"].CANVAS_WIDTH / 2;
                } else {
                  returningValue = _legacyVideo["default"].CANVAS_HEIGHT / 2 - rawValue;
                  if (_legacyVideo["default"].flipStatus.vertical) {
                    returningValue *= -1;
                  }
                }
                return _context12.abrupt("return", returningValue.toFixed(1));
              case 5:
                _context12.prev = 5;
                _t7 = _context12["catch"](2);
                return _context12.abrupt("return", 0);
              case 6:
              case "end":
                return _context12.stop();
            }
          }, _callee12, null, [[2, 5]]);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'ai_utilize_video'
    }
  };
};